"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var redux_observable_1 = require("redux-observable");
var epics_1 = require("utils/upload/epics");
var sokositeEntryAttachments_1 = require("actions/sokositeEntryAttachments");
var diaryentries_1 = require("@caddigital/sok-reducers/lib/actions/diaryentries");
var rxjs_1 = require("rxjs");
var operators_1 = require("rxjs/operators");
var epics = (0, epics_1.createEpics)('@sok/web/sokosite/entry/attachments', function (state) { return state.sokositeEntryAttachments; });
var searchOptions = {
    sortBy: null,
    order: 'desc',
    limit: 350,
    offset: 0
};
var refreshAttachments = function (state) {
    return diaryentries_1.EntryFolderListActions.fetchRequest((state.diaryentries.current.currentEntry &&
        state.diaryentries.current.currentEntry.folder_id) ||
        0, searchOptions);
};
var refreshImages = function (state) {
    return diaryentries_1.ImagesFolderListActions.fetchRequest((state.diaryentries.current.currentEntry &&
        state.diaryentries.current.currentEntry.images_folder_id) ||
        0, searchOptions);
};
function refreshOnDelete(action$, store, fetchOptions) {
    return action$.pipe((0, operators_1.filter)(function (action) { return action.type === '@sok/modules/files/crud/files/DELETE_SUCCESS'; }), (0, operators_1.mergeMap)(function (action) {
        var state = store.value;
        var parentId = Array.isArray(action.files) && action.files[0] && action.files[0].parent;
        var actions = [];
        if (state.diaryentries.current.currentEntry) {
            if (state.diaryentries.current.currentEntry.folder_id === parentId) {
                actions.push(refreshAttachments(state));
            }
            if (state.diaryentries.current.currentEntry.images_folder_id === parentId) {
                actions.push(refreshImages(state));
            }
        }
        return rxjs_1.of.apply(void 0, actions);
    }));
}
exports.default = (0, redux_observable_1.combineEpics)(epics.checkDuplicateFolder, epics.initFileUpload, epics.handleFileUpload, epics.cancelUploadSession, epics.saveOnFileUploadDone(function (state) { return [
    refreshAttachments(state),
    refreshImages(state),
    sokositeEntryAttachments_1.default.fileuploadDone()
]; }, function (err) { return [{ type: '@sokosite/upload/error', payload: err }]; }), refreshOnDelete);
